import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '@ui-kit/buttons/button/button.component';
import { FormLabelComponent } from '@ui-kit/form';
import { ButtonGroupModule } from 'primeng/buttongroup';

@Component({
    selector: 'btn-select',
    standalone: true,
    imports: [FormsModule, ButtonGroupModule, ButtonComponent, FormLabelComponent],
    templateUrl: './button-select.component.html',
    styleUrl: './button-select.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonSelectComponent {
    options = input.required<any>();
    value = model.required<any>();

    id = input<string>('');
    label = input<string>('');
    styleClass = input<string>('');
    fluid = input<boolean>(false);
    size = input<undefined | 'small' | 'large'>(undefined);

    disabled = input<boolean>(false);

    allowEmpty = input<boolean>(false);
    optionLabel = input<string | undefined>(undefined);
    optionValue = input<string | undefined>(undefined);

    onChange = output<any>();

    getButtonClass(option: any, first: boolean, last: boolean): string {
        const isSelected = this.value() === option.value;
        const hasMultipleOptions = this.options().length > 2;
        const isMiddleButton = !first && !last;

        if (isSelected) {
            if (hasMultipleOptions && isMiddleButton) {
                return 'middle-button';
            }
            if (last) {
                return 'last-button';
            }
            return '';
        } else {
            if (hasMultipleOptions && isMiddleButton) {
                return 'unselected middle-button';
            }
            if (last) {
                return 'unselected last-button';
            }
            return 'unselected';
        }
    }

    changeSelectedValue(option: any): void {
        if (this.allowEmpty() && this.value() === option.value) {
            this.value.set(null);
        } else {
            this.value.set(option.value);
        }
        this.onChange.emit(this.value());
    }
}
